// Post.js
import { connect } from 'react-redux';

import {
  POST_FEED_ASPECT_RATIO,
  SUBSCRIPTION_CURRENCY,
} from '../RemoteConfigKeys.js';
import Post from '../component/Post.jsx';
import withRouter from '../component/WithRouter.jsx';
import fetchUser from '../action/fetchUser.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchMessageRating from '../action/fetchMessageRating.js';
import fetchMessageSegments from '../action/fetchMessageSegments.js';
import submitMessageRating from '../action/submitMessageRating.js';
import sendChatStart from '../action/sendChatStart.js';
import toggleModal from '../action/toggleModal.js';
import fetchShortLink from '../action/fetchShortLink.js';
import copyTextWithToastr from '../action/copyTextWithToastr.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getShortLinkData from '../selector/getShortLinkData.js';
import getUsername from '../selector/getUsername.js';
import { ProductType, SHOP_ID } from '../resource/shopConstants.js';
import { getKeySystem } from '../resource/getDrmInfo.js';
import { COM_APPLE_FPS } from '../resource/drmConstants.js';
import i18n from '../resource/i18n.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import getShareLink from '../resource/getShareLink.js';
import { SHARE_CONTENT_PHOTO } from '../RemoteConfigKeys.js';
import fetchMeReferral from '../action/fetchMeReferral.js';

const isFairPlay = getKeySystem() === COM_APPLE_FPS;
const mapStateToProps = (
  state,
  { messageId, messageHeightFeedName, location }
) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const defaultSubscriptionCurrency = getRemoteConfigData(
    state,
    SUBSCRIPTION_CURRENCY
  );
  const meUsername = getMeData(state, 'username');
  const referralCode = getMeData(state, 'referralCode');
  const referralSignupRewardDiamond = getMeData(state, 'rewardReferral');

  const meId = getMeData(state, 'id');
  const selectPath = ['me', 'referral', meId];
  const isFetching = getNetworkingData(state, selectPath, 'isFetching');
  const isFetched = getNetworkingData(state, selectPath, 'isFetched');
  const shouldFetchReferral = !isFetching && !isFetched;
  const shareLink = getShareLink({
    pathname: `/post/${messageId}`,
  });
  const shortShareLink = shareLink ? getShortLinkData(state, shareLink) : null;
  const sourceLanguage = getMessageData(state, messageId, 'source_language');
  const currentLanguage =
    getOperationData(state, ['config'], 'language') || i18n.language;

  const shareI18nPhotoTemplates = getRemoteConfigData(
    state,
    SHARE_CONTENT_PHOTO
  );

  return {
    shareLink,
    shortShareLink,
    messageId,
    postedAtUnix: getMessageData(state, messageId, 'postedAtUnix'),
    scheduledAtUnix: getMessageData(state, messageId, 'scheduledAtUnix'),
    title: getMessageDataWithVariable(
      state,
      messageId,
      'title',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalTitle: getMessageDataWithVariable(
      state,
      messageId,
      'originalTitle',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    caption: getMessageDataWithVariable(
      state,
      messageId,
      'description',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalCaptionText: getMessageDataWithVariable(
      state,
      messageId,
      'originalCaptionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    senderName: getUserData(state, senderId, 'username'),
    displayedUsername: getUsername(state, senderId, 'displayName'),
    senderId,
    meId: getMeData(state, 'id'),
    isFairPlay,
    canViewMedia: getMessageData(state, messageId, 'canViewMedia'),
    shouldFetchMessageTranslation: true, // For withFetchTranslation
    likeCount: getMessageData(state, messageId, 'likes'),
    viewCount: getMessageData(state, messageId, 'views'),
    unlockPrice: getMessageData(state, messageId, 'unlockPrice'),
    mediaHeightInPostFeed: getMessageData(
      state,
      messageId,
      'mediaHeightInPostFeed'
    ),
    deviceWidth: getOperationData(state, ['device'], 'width'),
    messageHeight: getOperationData(
      state,
      ['feed', messageHeightFeedName, 'message', messageId],
      'messageHeight'
    ),
    ratedAs: getMessageData(state, messageId, 'ratedAs'),
    assetIds: getMessageData(state, messageId, 'assetIds'),
    subscriptionProductIds: getListData(
      state,
      [
        'shop',
        SHOP_ID.subscription,
        defaultSubscriptionCurrency,
        ProductType.SUBSCRIPTIONS,
        senderId,
      ],
      'itemIds'
    ),
    isOnPostFeed: !getIsMatchedPathname({
      pathname: location?.pathname,
      dataKey: 'isOnPostDetail',
    }),
    isFetchingShortShareLink: getNetworkingData(
      state,
      ['shortLink', shareLink],
      'isFetching'
    ),
    isPublished: getMessageData(state, messageId, 'isPublished'),
    aspectRatio: getRemoteConfigData(state, POST_FEED_ASPECT_RATIO),
    sourceLanguage,
    currentLanguage,
    referralCode,
    referralSignupRewardDiamond,
    shouldFetchReferral,
    shareI18nPhotoTemplates,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMessageDetail: ({ messageId, httpProxyHeaders }) =>
      dispatch(fetchMessageDetail({ id: messageId, httpProxyHeaders })),
    fetchUser: ({ id, httpProxyHeaders }) =>
      dispatch(fetchUser({ id, httpProxyHeaders })),
    fetchRating: ({ id }) => dispatch(fetchMessageRating({ id })),
    fetchMessageSegments: ({ messageId, manifestType }) =>
      dispatch(fetchMessageSegments({ messageId, manifestType })),
    submitRating: ({ id, rating }) =>
      dispatch(submitMessageRating({ id, rating })),
    sendChatStart: ({ userId }) => dispatch(sendChatStart({ userId })),
    toggleModal: ({ modalId, payload, isOpen }) =>
      dispatch(toggleModal({ modalId, payload, isOpen })),
    fetchShortLink: data => dispatch(fetchShortLink(data)),
    copyTextWithToastr: data => dispatch(copyTextWithToastr(data)),
    fetchMeReferral: () => dispatch(fetchMeReferral()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Post));
